import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {IYear} from "../../../../../data/data";
import {getYearData} from '../../../../../store/reducers/year';
import Calendar from '../../../../common/calendar/Calendar';
import {isYearAlreadyComplete} from '../../../../../store/reducers/calendar/isYearAlreadyComplete';
import Button from '../../../../common/ui/button/Button';
import {endYear} from '../../../../../store/actions/calendar/year';
import CloseButton from '../CloseButton';

interface Props
{
    onClose?: () => void;
    year: IYear;
    is_already_complete: boolean;
    endYear: () => void;
}

import './YearInfo.scss';


class YearInfo extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    render()
    {
        const {year:year_obj, is_already_complete, endYear} = this.props;
        const {year, headline, description} = year_obj;

        return <div styleName={'year-info'}>

            <CloseButton onClose={this.props.onClose}/>

            <span styleName={'header'}>happy new year!</span>

            <div styleName={'content'}>

                {/*<span styleName={'year-label'}>it's the year</span>*/}

                <span styleName={'calendar'}>

                    <Calendar year={year} year_intro={true}/>

                </span>

                {headline &&
                <p styleName={'headline'} dangerouslySetInnerHTML={{ __html: headline }}></p>}

                <p styleName={'description'} dangerouslySetInnerHTML={{ __html: description }}></p>

                {is_already_complete &&
                <div styleName={'year-complete'}>

                    <p>Looks like you've already hit the targets for this year - good work!</p>

                    <Button
                        type={'skip-year'}
                        onClick={endYear}>skip this year</Button>

                </div>}

            </div>

        </div>
    }
}


const mapStateToProps = state =>
{
    return {
        // season: getSeasonData(state)
        year: getYearData(state),
        is_already_complete: isYearAlreadyComplete(state),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {
        endYear: () => dispatch(endYear()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(YearInfo);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/modals/year-info/YearInfo.tsx